export default function FlytfirmaIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 16}
      height={height ? height : width ? width : 16}
      viewBox="0 0 15 15"
    >
      <g fill="currentColor" transform="translate(-0.25 -0.25)">
        <path
          d="M14.536,15.25a.714.714,0,0,1-.714-.714V8.046L7.75,1.974,1.679,8.046v6.49a.714.714,0,1,1-1.429,0V7.75a.714.714,0,0,1,.209-.505L7.245.459a.714.714,0,0,1,1.01,0l6.786,6.786a.714.714,0,0,1,.209.505v6.786A.714.714,0,0,1,14.536,15.25Z"
          transform="translate(0 0)"
        />
        <path
          d="M2.681-.5A3.181,3.181,0,1,1-.5,2.681,3.185,3.185,0,0,1,2.681-.5Zm0,4.943A1.762,1.762,0,1,0,.919,2.681,1.764,1.764,0,0,0,2.681,4.443Z"
          transform="translate(5.069 5.751)"
        />
        <path
          d="M13.564,22.365a.717.717,0,0,1-.676-.473,3.385,3.385,0,0,0-6.359,0,.719.719,0,0,1-.915.432.708.708,0,0,1-.437-.905,4.825,4.825,0,0,1,9.064,0,.708.708,0,0,1-.437.905A.723.723,0,0,1,13.564,22.365Z"
          transform="translate(-1.958 -7.115)"
        />
      </g>
    </svg>
  );
}
